import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { Period } from '../../../utils/types';
dayjs.extend(localizedFormat);

export const generateId = (): string => `edit${dayjs().format('x')}`;

export const comparePeriodStartTime = (period1: Period, period2: Period): number => {
	if (period1.source.startTime! < period2.source.startTime!) {
		return -1;
	}
	if (period1.source.startTime! > period2.source.startTime!) {
		return 1;
	}
	return 0;
};
